// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lessons-page {
  max-width: 800px;
  margin: 0 auto;
}

.lessons-page h1 {
  margin-bottom: 8px;
}

.subtitle {
  color: var(--text-light);
  margin-bottom: 24px;
}

/* Lesson Sets (Accordion) */
.lesson-sets {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.lesson-set {
  background: white;
  border-radius: 16px;
  box-shadow: var(--shadow);
  overflow: hidden;
  border-left: 5px solid var(--set-color);
}

.lesson-set.empty {
  opacity: 0.6;
}

.set-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background 0.2s;
}

.set-header:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.02);
}

.set-header:disabled {
  cursor: default;
}

.set-icon {
  width: 52px;
  height: 52px;
  background: var(--set-color);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  flex-shrink: 0;
}

.set-info {
  flex: 1 1;
}

.set-info h2 {
  font-size: 18px;
  margin-bottom: 4px;
  color: var(--text);
}

.set-stats {
  font-size: 13px;
  color: var(--text-light);
}

.set-arrow {
  font-size: 14px;
  color: var(--text-light);
  transition: transform 0.3s;
}

.set-arrow.open {
  transform: rotate(180deg);
}

/* Lessons inside set */
.set-lessons {
  border-top: 1px solid #eee;
  padding: 8px;
  background: #fafafa;
}

.set-lessons .lesson-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 8px;
  text-decoration: none;
  color: var(--text);
  transition: transform 0.2s, box-shadow 0.2s;
  border: none;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

.set-lessons .lesson-card:last-child {
  margin-bottom: 0;
}

.set-lessons .lesson-card:hover {
  transform: translateX(4px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
}

.lesson-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.lesson-info {
  flex: 1 1;
}

.lesson-info h3 {
  font-size: 15px;
  margin-bottom: 4px;
}

.lesson-meta {
  display: flex;
  gap: 10px;
  font-size: 12px;
}

.word-count,
.sentence-count {
  color: var(--text-light);
}

.completed-badge {
  color: var(--success);
  font-weight: 600;
}

.lesson-arrow {
  color: var(--text-light);
  font-size: 16px;
}

.loading {
  text-align: center;
  padding: 40px;
  font-size: 18px;
  color: var(--text-light);
}

/* Difficult words banner */
.difficult-words-banner {
  display: flex;
  align-items: center;
  gap: 16px;
  background: linear-gradient(135deg, #FF6B6B, #FF8E53);
  color: white;
  border-radius: 16px;
  padding: 16px 20px;
  margin-bottom: 24px;
  text-decoration: none;
  box-shadow: var(--shadow);
  transition: transform 0.2s;
}

.difficult-words-banner:hover {
  transform: scale(1.02);
}

.banner-icon {
  font-size: 36px;
}

.banner-text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.banner-text strong {
  font-size: 18px;
}

.banner-text span {
  font-size: 14px;
  opacity: 0.9;
}

.banner-arrow {
  font-size: 24px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/Lessons.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".lessons-page {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.lessons-page h1 {\n  margin-bottom: 8px;\n}\n\n.subtitle {\n  color: var(--text-light);\n  margin-bottom: 24px;\n}\n\n/* Lesson Sets (Accordion) */\n.lesson-sets {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.lesson-set {\n  background: white;\n  border-radius: 16px;\n  box-shadow: var(--shadow);\n  overflow: hidden;\n  border-left: 5px solid var(--set-color);\n}\n\n.lesson-set.empty {\n  opacity: 0.6;\n}\n\n.set-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 20px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.2s;\n}\n\n.set-header:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.set-header:disabled {\n  cursor: default;\n}\n\n.set-icon {\n  width: 52px;\n  height: 52px;\n  background: var(--set-color);\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  flex-shrink: 0;\n}\n\n.set-info {\n  flex: 1;\n}\n\n.set-info h2 {\n  font-size: 18px;\n  margin-bottom: 4px;\n  color: var(--text);\n}\n\n.set-stats {\n  font-size: 13px;\n  color: var(--text-light);\n}\n\n.set-arrow {\n  font-size: 14px;\n  color: var(--text-light);\n  transition: transform 0.3s;\n}\n\n.set-arrow.open {\n  transform: rotate(180deg);\n}\n\n/* Lessons inside set */\n.set-lessons {\n  border-top: 1px solid #eee;\n  padding: 8px;\n  background: #fafafa;\n}\n\n.set-lessons .lesson-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: white;\n  border-radius: 12px;\n  padding: 12px 16px;\n  margin-bottom: 8px;\n  text-decoration: none;\n  color: var(--text);\n  transition: transform 0.2s, box-shadow 0.2s;\n  border: none;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n}\n\n.set-lessons .lesson-card:last-child {\n  margin-bottom: 0;\n}\n\n.set-lessons .lesson-card:hover {\n  transform: translateX(4px);\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);\n}\n\n.lesson-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.lesson-info {\n  flex: 1;\n}\n\n.lesson-info h3 {\n  font-size: 15px;\n  margin-bottom: 4px;\n}\n\n.lesson-meta {\n  display: flex;\n  gap: 10px;\n  font-size: 12px;\n}\n\n.word-count,\n.sentence-count {\n  color: var(--text-light);\n}\n\n.completed-badge {\n  color: var(--success);\n  font-weight: 600;\n}\n\n.lesson-arrow {\n  color: var(--text-light);\n  font-size: 16px;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  font-size: 18px;\n  color: var(--text-light);\n}\n\n/* Difficult words banner */\n.difficult-words-banner {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: linear-gradient(135deg, #FF6B6B, #FF8E53);\n  color: white;\n  border-radius: 16px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  text-decoration: none;\n  box-shadow: var(--shadow);\n  transition: transform 0.2s;\n}\n\n.difficult-words-banner:hover {\n  transform: scale(1.02);\n}\n\n.banner-icon {\n  font-size: 36px;\n}\n\n.banner-text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.banner-text strong {\n  font-size: 18px;\n}\n\n.banner-text span {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.banner-arrow {\n  font-size: 24px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
